import Feature from "ol/Feature";
import Polygon from "ol/geom/Polygon";
import {Translate} from "ol/interaction";
import VectorSource from "ol/source/Vector";
import {Fill, Stroke, Style} from 'ol/style.js';
import {store} from "../../helper/store";
import {yChanger} from "../../redux_actions/bloodConfig.action";
import Slidemap from "./Slidemap";

class BloodPreviewSlideMap extends Slidemap {

    previewLineStyle = new Style({
        stroke: new Stroke({
            color: '#7CFC00',
            width: 5,
        }), fill: new Fill({
            color: 'rgba(256, 256, 256, 0.1)'
        }),
    })

    previewLineStyleGray = new Style({
        stroke: new Stroke({
            color: '#424240',
            width: 5,
        }),
        fill: new Fill({
            color: 'rgb(100,100,100, 0.1)'
        }),
    })

    previewLineStyleSelected = new Style({
        stroke: new Stroke({
            color: 'blue',
            width: 5,
        }),
        fill: new Fill({
            color: 'rgba(256, 256, 256, 0.1)'
        }),
    })

    disableRotate = true

    componentDidMount() {
        super.componentDidMount();

        if (this.props.slide) {

            // We are using the annotation layer to show the monolayer detection bars
            this.previewLayer = this.map.getLayers().getArray().find(layer => layer.getProperties().id === "previewblood");

            let yTop = this.props.y_top
            let yBottom = this.props.y_bottom
            let slide = this.props.slide;
            let txtyInfo = this.props.slide.txty
            let yTopPosition = undefined;
            let yBottomPosition = undefined;
            let xTopPosition = undefined;
            let xBottomPosition = undefined;
            for (let key in txtyInfo) {
                if (txtyInfo.hasOwnProperty(key) && yTopPosition === undefined && parseInt(txtyInfo[key].y_index) === parseInt(yTop)) {
                    yTopPosition = txtyInfo[key]['pos']['Y'];
                    xTopPosition = txtyInfo[key]['pos']['X'];
                }
                if (txtyInfo.hasOwnProperty(key) && yBottomPosition === undefined && parseInt(txtyInfo[key].y_index) === parseInt(yBottom)) {
                    yBottomPosition = txtyInfo[key]['pos']['Y'];
                    xBottomPosition = txtyInfo[key]['pos']['X'];
                }
            }
            yTopPosition = (slide.stitched_tile_height * (slide.stitched_y_max) - yTopPosition);
            yBottomPosition = (slide.stitched_tile_height * (slide.stitched_y_max) - yBottomPosition);

            this.previewLayer.setSource(this.getVectorSource(yTopPosition, yBottomPosition))
            this.previewLayer.setStyle(this.previewLineStyleGray);

            let animationZoom = this.getAnimationZoom(yBottomPosition, yTopPosition);

            let centrePosY = (yBottomPosition + (yTopPosition - yBottomPosition) / 2);
            let centerPosX = (xBottomPosition + (xTopPosition - xBottomPosition) / 2);

            this.map.getView().animate({
                center: [centerPosX, centrePosY], zoom: animationZoom, duration: 0
            })

            this.translate = new Translate({
                features: this.selectInteraction.getFeatures(),
                style: this.previewLineStyleGray
            });

            this.translate.on('translateend', e => {
                e.features.forEach(feature => {
                    if (feature.getId()) {
                        this.changeYPosn(feature);
                    }
                })
            })

            this.map.getView().setRotation(Math.PI / 2)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        super.componentDidUpdate(prevProps, prevState, snapshot);

        if (prevProps.overrideScanRegion !== this.props.overrideScanRegion) {
            if (this.props.overrideScanRegion) {
                this.previewLayer.values_.onFeatureSelect = (feature) => {feature.setStyle(this.previewLineStyleSelected)};
                this.map.addInteraction(this.translate);
                this.map.addInteraction(this.selectInteraction);

                this.previewLayer.setStyle(this.previewLineStyle);
                this.previewLayer.getSource().getFeatures().map(feat => feat.setStyle(this.previewLineStyle))
            } else {
                this.previewLayer.values_.onFeatureSelect = () => null;
                this.map.removeInteraction(this.translate);
                this.map.removeInteraction(this.selectInteraction);

                this.previewLayer.setStyle(this.previewLineStyleGray);
                this.previewLayer.getSource().getFeatures().map(feat => feat.setStyle(this.previewLineStyleGray))
            }
        }
    }

    changeYPosn = (feature) => {
        if (feature.getId() === 1) {
            this.setState({
                yTopPosition: feature.getGeometry().getExtent()[3]
            })
            store.dispatch(yChanger(feature.getGeometry().getExtent()[3], this.props.slide.txty, this.props.slide, "BOTTOM"))
        } else if (feature.getId() === 2) {
            this.setState({
                yBottomPosition: feature.getGeometry().getExtent()[1]
            })
            store.dispatch(yChanger(feature.getGeometry().getExtent()[1], this.props.slide.txty, this.props.slide, "TOP"))
        }
    }

    getAnimationZoom = (point1, point2) => {
        let zoomLevel = 5;
        let diff = point2 - point1;
        if (diff > 50000) return 1;
        else if (diff > 30000) return 2;
        else if (diff > 15000) return 3;
        else if (diff > 7500) return 4;
        return zoomLevel;
    }

    getVectorSource = (yTopPosition, yBottomPosition) => {
        const u_x1 = -1 * Math.pow(10, 6)
        const u_y1 = -1 * Math.pow(10, 6)
        const b_x1 = Math.pow(10, 6)
        const b_y1 = yBottomPosition
        let grayFeature1 = new Feature({
            geometry: new Polygon([[[u_x1, u_y1], [b_x1, u_y1], [b_x1, b_y1], [u_x1, b_y1], [u_x1, u_y1]]]), id: 1
        })
        grayFeature1.setId(1)
        const u_x2 = Math.pow(10, 6)
        const u_y2 = Math.pow(10, 6)
        const b_x2 = -1 * Math.pow(10, 6)
        const b_y2 = yTopPosition
        let grayFeature2 = new Feature({
            geometry: new Polygon([[[u_x2, u_y2], [b_x2, u_y2], [b_x2, b_y2], [u_x2, b_y2], [u_x2, u_y2]]]), id: 2
        })
        grayFeature2.setId(2);

        if (this.props.overrideScanRegion) {
            this.previewLayer.setStyle(this.previewLineStyle)
            grayFeature1.setStyle(this.previewLineStyle)
            grayFeature2.setStyle(this.previewLineStyle)
        } else {
            this.previewLayer.setStyle(this.previewLineStyleGray)
            grayFeature1.setStyle(this.previewLineStyleGray)
            grayFeature2.setStyle(this.previewLineStyleGray)
        }

        return new VectorSource({
            features: [grayFeature1, grayFeature2], wrapX: false
        })
    }

}

export default BloodPreviewSlideMap;